export default {
  name: 'RTLMixin',
  head() {
    return {
      htmlAttrs: {
        dir: this.$direction(),
      },
    }
  },
}
